import request from "./request";

const FAQService = {
    GetFAQCategories: async (context, signal) => {
        return await request.sendRequest(`/faq/categories/all`, context.token, signal);
    },
    GetAllFAQs: async (context, signal) => {
        return await request.sendRequest(`/faq/all`, context.token, signal);
    },
    GetAll: async (type, context, signal) => {
        return await request.sendRequest(`/faq/all/${type}`, context.token, signal);
    },
    SearchFAQs: async (searchText, context, signal) => {
        return await request.sendRequest(`/faq/search/${searchText}`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/faq/${id}`, context.token, signal);
    },
    Import: async (payload, context) => {
        return await request.sendFormDataRequest(`/faq/import`, payload, context);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/faq`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/faq/${id}`, context.token);
    },
};

export default FAQService;
